module.exports = "/_next/static/images/landing4-fb21a124fd7835b272cc2ec8f25602cb.png";